type State = {
    loading: boolean;
    noStockFilter: boolean;
    textFilter: string | null;
    items: any[];
    allItems: any[];
    selectedVariants: SelectVariant[];
    viewStyle: ViewStyle;
};

type ViewStyle = "threeColumns" | "twoColumns";

type SelectVariant = {
    parent: number;
    child: number;
};

const defaultState: State = {
    loading: false,
    noStockFilter: false,
    textFilter: null,
    items: [],
    allItems: [],
    selectedVariants: [],
    viewStyle: "threeColumns",
};

export type { State, SelectVariant, ViewStyle };
export { defaultState };
